import React, {useEffect, useRef, useState} from 'react';

import Button from "react-bootstrap/Button";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Image from 'react-bootstrap/Image';
import Card from 'react-bootstrap/Card';

import {dateToDE} from '../util/Util.js';


/*
Renders a Kairogramm with support for printing
 */
const Kairogramm = ({
	client,
	kairogramm,
	baseUrl,
	onPrint,
	print,
}) => {
	const date = kairogramm.kairosDate;
	const kairosClock = `${baseUrl}/KAIROSCLOCK`;
	const lifePhases = `${baseUrl}/LIFEPHASES`;
	const generationField = `${baseUrl}/GENERATIONFIELD`;

	const table = (
		<Table>
			<thead>
				<tr>
					{kairogramm.kairogrammTabelle.header.map(col => (
						<th
							key = {col}>
							{col}
						</th>
					))}
				</tr>
			</thead>
			<tbody>
				{kairogramm.kairogrammTabelle.rows
						.sort((r1, r2) => r1.values[0] - r2.values[0])
						.map((row, idx) => (
							<tr key = {`row_${idx}`}>
								{row.values.map((col, cIdx) => (
									<td
										key = {kairogramm.kairogrammTabelle.header[cIdx]}>
										{col}
									</td>
								))}
							</tr>
				))}
			</tbody>
		</Table>
	);

	const suffix = `von ${client.surname}, ${client.name} zum Kairos-Datum ${dateToDE(date)}`;

	const banner = (
		<div>
			<a href={'https://xeller.info'}
			   target = '_blank'>
				<img src={'https://xeller.info/wp-content/uploads/2018/03/GX_Logo_9pt_4c_neu.jpg'}
					 height={'40px'}
					 alt={'Xeller Training Logo'}
				/>
			</a>
			<div>
				<b>{'Kairos Software'}</b>
			</div>
		</div>
	);


	// if requested, print once images are loaded

	const [nLoaded, setNLoaded] = useState(0);
	const incLoaded = () => setNLoaded(loaded => ++loaded);

	useEffect(() => {
		if (print && nLoaded === 3) {
			// TODO print page without showing it: https://developer.mozilla.org/en-US/docs/Web/Guide/Printing#examples
			window.print();
			window.close();
		}
	}, [nLoaded])



	// render

	return (
		<div id={'kairogram'}>
			<div className = {'m-3'}>
				<Row className = {'justify-content-between'}>
					<Col className={'col-2'}>
						{banner}
					</Col>
					<Col xs={'auto'}>
						<Button
							onClick={onPrint}
							className={'d-print-none'}>
							<i className={'bi bi-printer'}/>
						</Button>
					</Col>
				</Row>
			</div>

			<Card
				className = {'my-3'}>
				<Card.Header className = {'text-center h4'}>
					{`KAIROS Uhr von ${client.surname}, ${client.name}`}
				</Card.Header>
					<ImageWithCallback className = {'analysis-image'}
						id = {'kairos-clock'}
						onload = {incLoaded}
						src = {kairosClock}/>
			</Card>

			<Card
				className = {'my-3'}>
				<Card.Header className = {'text-center h4'}>
					{`Kairos-Code ${suffix}`}
				</Card.Header>
				{table}
			</Card>

			{/* pagebreak*/}
			<div className={'break-after'}/>

			<Card
				className = {'my-3'}>
				<Card.Header className = {'text-center h4'}>
					{`Generationsfeld ${suffix}`}
				</Card.Header>
				<ImageWithCallback
					className = {'analysis-image'}
					id = {'generation-field'}
					onload = {incLoaded}
					src = {generationField}/>
			</Card>

			<Card
				className = 'my-3'>
				<Card.Header className = {'text-center h4'}>
					{`Die aktuelle Lebensphase ${suffix}`}
				</Card.Header>
				<ImageWithCallback
					className = {'analysis-image'}
					id = {'life-phases'}
					onload = {incLoaded}
					src = {lifePhases}/>
			</Card>
					<Container className = {'my-4'}>
						<Row className={'multiline-text'}>
							<Col>
								<div className = {'mb-2'}>
									{'Impressum:'}
								</div>
								<div>
									<b>{'Kairos Software'}</b>
								</div>
								<div>
									<b>{'Xeller Training'}</b>
								</div>
								<div>
									{'Gerd Xeller' +
										'\nDrosselweg 7' +
										'\n88471 Laupheim' +
										'\nTelefon: 07392/9381399' +
										'\nmobil: 0170/2960829' +
										'\nFax: 07392/9387547'}
								</div>
								<div>
									<a href = {'https://www.xeller.info'}
									   target = '_blank'>
										{'www.xeller.info'}
									</a>
								</div>
							</Col>
						</Row>
					</Container>
		</div>
	);
};

export default Kairogramm;


const ImageWithCallback = ({
	src,
	onload,
	className,
	id,
}) => {
	const ref = useRef();

	useEffect(() => {
		ref.current.onload = onload;

		return () => {
			ref.current.onload = null;
		};
	})

	return (
		<Image className = {className}
			id = {id}
			ref = {ref}
			src = {src}/>
	)
};
